import SHA256 from "crypto-js/sha256";
import Hex from "crypto-js/enc-hex";

const generateTimeEntryDateSignature = (
  payload: string,
  appSecret: string
): string => {
  const sourceString = appSecret + payload;

  return SHA256(sourceString).toString(Hex);
};

const toUtcDateString = (dateInputValue: string) => {
  const [year, month, day] = dateInputValue.split("-").map(Number);
  const utcDate = new Date(Date.UTC(year, month - 1, day));
  return utcDate.toISOString().slice(0, 10);
};

const getUtcNowInMinutes = () => {
  return Math.floor(Date.now() / 1000 / 60);
};

export const generateHashTimeEntries = (
  startDateValue: string,
  userId: string | null | undefined
) => {
  const appSecret = "81ABfQjRvrDVeiFwFhF5S2a6TG9t8nrKlq5S3wjA9klBCfVxl4neTkuUxUWPgBhU";

  const startDateUtc = toUtcDateString(startDateValue);
  const utcNowMinutes = getUtcNowInMinutes();

  const payload = `${startDateUtc}${userId}${utcNowMinutes}`;

  const hash = generateTimeEntryDateSignature(payload, appSecret);
  return hash;
};
